import { Feature, NavItem, PricingPlan, Testimonial } from '../types';

export const navItems: NavItem[] = [
  { label: 'How It Works', href: '#use-cases' },
  { label: 'Integrations', href: '#integrations' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Trust', href: '/trust' },
];

export const features: Feature[] = [
  {
    title: 'Natural Conversations',
    description: 'Our AI engages in fluid, natural conversations that feel genuinely human.',
    icon: 'MessageSquare',
  },
  {
    title: 'Advanced Learning',
    description: 'Proprietary algorithms that continuously improve through interaction and feedback.',
    icon: 'Brain',
  },
  {
    title: 'Seamless Integration',
    description: 'Easily integrate with existing platforms and systems via our comprehensive API.',
    icon: 'Plug',
  },
  {
    title: 'Customizable Personas',
    description: 'Create and customize AI personas tailored to your specific business needs.',
    icon: 'Users',
  },
  {
    title: 'Multi-language Support',
    description: 'Communicate fluently in over 40 languages with regional dialect awareness.',
    icon: 'Globe',
  },
  {
    title: 'Enhanced Security',
    description: 'Enterprise-grade security with data encryption and privacy compliance.',
    icon: 'Shield',
  },
];

// Testimonials will be loaded from the database once early access users provide verified feedback
export const testimonials: Testimonial[] = [];

export const pricingPlans: PricingPlan[] = [
  {
    title: 'Starter',
    price: '$299',
    description: 'Perfect for small businesses just getting started with AI.',
    features: [
      '1 AI Assistant',
      '5,000 interactions/month',
      'Basic customization',
      'Email support',
      'Standard security',
    ],
    buttonText: 'Get Started',
  },
  {
    title: 'Professional',
    price: '$699',
    description: 'Ideal for growing businesses with moderate AI needs.',
    features: [
      '3 AI Assistants',
      '25,000 interactions/month',
      'Advanced customization',
      'Priority support',
      'Enhanced security',
      'API access',
    ],
    buttonText: 'Choose Pro',
    popular: true,
  },
  {
    title: 'Enterprise',
    price: 'Custom',
    description: 'Tailored solutions for large organizations with complex requirements.',
    features: [
      'Unlimited AI Assistants',
      'Unlimited interactions',
      'Full customization',
      'Dedicated support team',
      'Enterprise-grade security',
      'Advanced analytics',
      'White-labeling',
    ],
    buttonText: 'Contact Us',
  },
];